/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {useMemo} from 'react'
import PropTypes from 'prop-types'

import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const PromoCallout = ({priceData = {}, product, ...extraProps}) => {
    // NOTE: Fixed API data inconsistency in findLowestPrice - productPromotions || c_productPromotions
    let calloutMessage = priceData?.promoCalloutMsg || null

    // get product callout message:
    // case 1: PLP, PLP - if product callout message but no promotionalPrice, case: buy X and get Y
    // case 2: any applied promo on cart / checkout / order pages
    if (!calloutMessage) {
        const productPromotions = product?.productPromotions ?? []
        const productPromotion = productPromotions[0] ?? {}
        const promotionId = productPromotion?.promotionId || null
        const isProductPromotionalPricePromo =
            promotionId && priceData.promotionalPricePromoIds?.includes(promotionId)

        if (!isProductPromotionalPricePromo) {
            calloutMessage = productPromotion?.calloutMsg || null
        }
    }

    // calloutMsg can be html string or just plain text
    return calloutMessage ? (
        <Text
            variant="bodyBase2"
            color="white"
            bg="fullBlack"
            p={'2px 0 1px'}
            lineHeight={'shorter'}
            data-testid="promo-callout"
            dangerouslySetInnerHTML={{__html: calloutMessage}}
            {...extraProps}
        />
    ) : null
}

PromoCallout.propTypes = {
    priceData: PropTypes.object,
    product: PropTypes.object
}

export default PromoCallout
